import styled from 'styled-components';

export const Container =styled.div`
.bodyFixed {
    overflow: hidden;
  }
  .cm__modalWraper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    overflow: scroll;
    bottom: 0;
    right: 0;
    animation: modalAnimation 0.2s ease-in-out forwards;
    z-index: 999;
  }
  .cm__modalWraper.centerMode {
    display: flex;
    align-items: center;
  }
  .cm__modal {
    border-radius: 10px;
    background-color: #ffffff;
    position: relative;
    top: 40px;
    margin: 0 auto;
    margin-bottom: 80px;
    z-index: 14;
  }
  .cm__modalClose {
    background-color: #fff;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 20px;
    top: 20px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    z-index: 14;
    cursor: pointer;
  }
  .cm__modalClose.modalCloseCenter {
    position: absolute;
    right: -40px;
    top: 0;
  }
  .cm__modalClose:hover {
    opacity: 1;
  }
  .cm__modalClose:before,
  .cm__modalClose:after {
    position: absolute;
    left: 12px;
    content: " ";
    height: 14px;
    width: 2px;
    background-color: #000;
  }
  .cm__modalClose:before {
    transform: rotate(45deg);
  }
  .cm__modalClose:after {
    transform: rotate(-45deg);
  }
  
  .cm__modalContent {
  }
  .cm__modalBackdrop {
    z-index: 11;
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }
  
  @keyframes modalAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  /*Right to Left*/
  html[dir="rtl"] .cm__modalClose.modalCloseCenter {
    right: calc(100% + 40px);
  }
s  
`;
